module.exports = __webpack_public_path__ + "img/eye-in-client-king-tours.8b1fd0c9.webp";